import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import _isEqualWith from 'lodash/isEqualWith';
import _find from 'lodash/find';

export const checkEmptyString = (str) => {
    return typeof str === 'string' ? !!str.replace(/\s/g, '').length : !!str;
};
export const checkValidEmail = (email) => {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;//eslint-disable-line
  return re.test(String(email).toLowerCase());
};
export const needToUpdateField = (a, b) => {
  if (typeof a === 'string' || typeof b === 'string') {
      return a !== b && (checkEmptyString(a) || checkEmptyString(b));
  }
  if (typeof a === 'object' || typeof b === 'object') {
      return !_isEqual(a, b) && (!_isEmpty(a) || !_isEmpty(b));
  }
  if (Array.isArray(a) || Array.isArray(b)) {
      return !_isEqualWith(a.sort(), b.sort(), (f, s) => f === s);
  }
  if (typeof a === 'number' || typeof b === 'number') {
      return a !== b;
  }
  return a !== b;
};
export const getRepresentation = (representations, variant) => {
    const foundRepresentation = _find(representations, r => r.name === variant);

    return foundRepresentation?.url ?? null;
};
export const getRandomString = (length) => {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    
    return result;
};
export const linkify = (text) => {
  const parseText = () => {
    const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
    const matches = !!text ? text.match(urlRegex) : null;
    if (!matches) {
      return <span>{text}</span>;
    }
    const result = [];
    let index = 0;
    const addResult = (content) => {
      result.push(<span key={index++}>{content}</span>);
    };
    for (const part of text.split(urlRegex)) {
      const isLink = matches.includes(part);
      if (isLink) {
        const trimmedPart = part.replace(/(^[^\w\d]+)|([^\w\d]+$)/g, '');
        if (trimmedPart) {
          const isWWWLink = part.startsWith('www.');
          const linkHref = isWWWLink ? `http://${trimmedPart}` : trimmedPart;
          let lastCharIndex = part.length - 1;
          while (lastCharIndex >= 0 && !part[lastCharIndex].match(/[a-zA-Z\d]/)) {
            lastCharIndex--;
          }
          const linkContent = lastCharIndex >= 0 ? part.slice(0, lastCharIndex + 1) : part;
          const remainingChars = lastCharIndex >= 0 ? part.slice(lastCharIndex + 1) : '';
          addResult(
            <React.Fragment key={index++}>
              <a href={linkHref} target="_blank" rel="noopener noreferrer">
                {linkContent}
              </a>
              {remainingChars && <span>{remainingChars}</span>}
            </React.Fragment>
          );
        }
      } else {
        addResult(part);
      }
    }
    return result.length === 1 ? result[0] : result;
  };
  return parseText();
};
export const toIsoString = (date) => {
  let tzo = -date.getTimezoneOffset(),
    dif = tzo >= 0 ? '+' : '-',
    pad = function (num) {
      return (num < 10 ? '0' : '') + num;
    };

  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    dif +
    pad(Math.floor(Math.abs(tzo) / 60)) +
    ':' +
    pad(Math.abs(tzo) % 60)
  );
};
export const getDateWithNullTimeZone = (date) => {
  return date.substring(0, date.indexOf('T')) + 'T00:00:00.000Z';
};
export const formatDuration = (time) => {
  const [hours, minutes] = time.split(':').map(Number);

  if (hours === 0 && minutes === 0) {
    return 'PT0S';
  }

  let duration = 'PT';

  if (hours > 0) {
    duration += `${hours}H`; 
  }
  
  if (minutes > 0) {
    duration += `${minutes}M`;
  }

  return duration;
};
export const parseDuration = (duration, type = 'time') => {
  const regex = /PT(?:(\d+)H)?(?:(\d+)M)?/;
  const matches = duration.match(regex);

  const hours = matches[1] ? parseInt(matches[1]) : 0; 
  const minutes = matches[2] ? parseInt(matches[2]) : 0;

  return  type === 'time' ? (hours > 0 ? `${String(hours).padStart(2, '0')}:` : '00:') + 
         `${String(minutes).padStart(2, '0')}` : `${String(minutes).padStart(2, '0')}`;
};
